module.exports = __webpack_public_path__ + "img/1697370662499-IMG_7076.png.8157ab5f.webp";